/**
 * Tâche 1150 (Eric 2026-06-16) — Tester toutes les familles d'un coup.
 *
 * Tester huit familles une par une, personne ne le fait. Un bouton, un
 * résultat par ligne : parti / pas parti, à qui, et pourquoi pas.
 */
import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { CheckCircle, TestTube, XCircle } from "@phosphor-icons/react";

const API = process.env.REACT_APP_BACKEND_URL;

export const TestAllFamiliesButton = () => {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true);
    try {
      const res = await axios.post(
        `${API}/api/system-notifications/test-all`,
        {},
        { withCredentials: true }
      );
      setRows(res.data.rows || []);
      toast.success(
        `${res.data.sent_count}/${res.data.total} famille(s) ont reçu le test`
      );
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Test impossible");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="test-all-families">
      <button
        type="button"
        onClick={run}
        disabled={busy}
        className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-zinc-300 text-sm text-zinc-700 hover:bg-zinc-50 disabled:opacity-50"
        data-testid="test-all-button"
      >
        <TestTube size={16} />
        {busy ? "Test en cours…" : "Tester toutes les familles"}
      </button>

      {rows && (
        <ul className="mt-3 space-y-1.5" data-testid="test-all-results">
          {rows.map((r) => (
            <li
              key={r.family}
              className="flex items-start gap-2 text-sm"
              data-testid={`test-all-row-${r.family}`}
            >
              {r.sent ? (
                <CheckCircle size={16} className="mt-0.5 shrink-0 text-emerald-600" />
              ) : (
                <XCircle size={16} className="mt-0.5 shrink-0 text-zinc-400" />
              )}
              <span>
                <span className="font-medium text-zinc-900">{r.label}</span>
                {r.sent ? (
                  <span className="text-emerald-700">
                    {" "}
                    — envoyé à {r.recipients.join(", ")}
                  </span>
                ) : (
                  <span className="text-zinc-500"> — non envoyé : {r.reason}</span>
                )}
                {r.failed?.length ? (
                  <span className="block text-xs text-red-700">
                    Refusé pour : {r.failed.join(", ")}
                  </span>
                ) : null}
              </span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TestAllFamiliesButton;
